import {Button} from '@mui/material';
import {AnimateButton} from 'components/Theme';
import React from 'react';
import {FieldsRendererProps} from '../FieldsRenderer';

interface RenderActionProps extends FieldsRendererProps {}

export const RenderAction: React.FC<RenderActionProps> = ({field}) => {
    return (
        <AnimateButton>
            <Button fullWidth variant="contained" key={field.uniqueId} type="submit">
                {field.title}
            </Button>
        </AnimateButton>
    );
};

export default RenderAction;
